export default __webpack_public_path__ + "static/media/react.1495a6a0.svg";